<template>
  <b-card class="cardboardTop" title="Please tell us about the electronic devices involved.">
    <b-alert variant="primary" show>
      <font-awesome-icon :icon="['fas', 'info-circle']"></font-awesome-icon>&nbsp;&nbsp;This item will not be added until you click the
      <b>'Add property'</b> button below
    </b-alert>

       <transition name="fade" mode="out-in">
          <div id="errorCardTop" class="errorCard" v-if="error == true">
            <b-card class="errorCard">
              <h1>Validation Errors</h1>

              <ul>
                <li
                  v-for="(item, index) in errormessage"
                  v-bind:key="errormessage[index]"
                >{{ item }}</li>
              </ul>

              <span>
                <i>Please correct all the above validation errors before you can add this property</i>
              </span>
            </b-card>
          </div>
        </transition>



    <b-form-group>
      <b-row>
        <b-col cols="2" v-on:click="Property.type == 'Mobile phone'">
          <div
            v-on:click="Property.type == 'Mobile phone'"
            v-bind:class="{ npfactive: Property.type == 'Mobile phone', npfnonActive :Property.type != 'Mobile phone' }"
          >
            <input
              v-on:click="Property.type == 'Mobile phone'"
              type="radio"
              id="MPType"
              value="Mobile phone"
              v-model="Property.type"
            >
            <label for="MPType">Mobile phone</label>
          </div>
        </b-col>
        <b-col cols="2" v-on:click="Property.type == 'iPad or other tablet'">
          <div
            v-on:click="Property.type == 'iPad or other tablet'"
            v-bind:class="{ npfactive: Property.type == 'iPad or other tablet', npfnonActive :Property.type != 'iPad or other tablet' }"
          >
            <input
              v-on:click="Property.type == 'iPad or other tablet'"
              type="radio"
              id="tabType"
              value="iPad or other tablet"
              v-model="Property.type"
            >
            <label for="tabType">iPad or other tablet</label>
          </div>
        </b-col>

        <b-col cols="2" v-on:click="Property.type == 'Laptop computer'">
          <div
            v-on:click="Property.type == 'Laptop computer'"
            v-bind:class="{ npfactive: Property.type == 'Laptop computer', npfnonActive :Property.type != 'Laptop computer' }"
          >
            <input type="radio" id="LTType" value="Laptop computer" v-model="Property.type">
            <label v-on:click="Property.type == 'Laptop computer'" for="LTType">Laptop computer</label>
          </div>
        </b-col>
           <b-col cols="2" v-on:click="Property.type == 'Camera'">
          <div
            v-on:click="Property.type == 'Camera'"
            v-bind:class="{ npfactive: Property.type == 'Camera', npfnonActive :Property.type != 'Camera' }"
          >
            <input type="radio" id="cType" value="Camera" v-model="Property.type">
            <label v-on:click="Property.type == 'Camera'" for="cType">Camera</label>
          </div>
        </b-col>
          
          
        <b-col cols="2" v-on:click="Property.type == 'Other'">
          <div
            v-on:click="Property.type == 'Other'"
            v-bind:class="{ npfactive: Property.type == 'Other', npfnonActive :Property.type != 'Other' }"
          >
            <input
              v-on:click="Property.type == 'Other'"
              type="radio"
              id="TypeOther"
              value="Other"
              v-model="Property.type"
            >
            <label for="TypeOther">Other</label>
          </div>
        </b-col>
      </b-row>
    </b-form-group>

    <b-form-group>
      <b-row>
        <b-col cols="12">
          <span class="npfQuestion">Make and model</span>
          <br>
          <span class="npfsubquestion">For example, Samsung Galaxy S10</span>
          <b-form-input v-model="Property.makeandmodel"  placeholder="Samsung Galaxy S10"></b-form-input>
        </b-col>
      </b-row>
    </b-form-group>
    
    <b-form-group>
      <b-row>
        <b-col cols="12">
          <span class="npfQuestion">IMEI code or serial number, if known</span>
      
          <b-form-input v-model="Property.imei"  placeholder=""></b-form-input>
        </b-col>
      </b-row>
       <b-row>
        <b-col cols="12">
            <div v-b-toggle.collapse-imei class="npflink">
          <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon>&nbsp;<span class="npfsubquestion">Where can I find my IMEI code?</span>
 
            </div>

<b-collapse id="collapse-imei" >
    <br>
    <b-alert show variant="primary">
<span class="npfsubquestion">Your IMEI code is a 15 digit number unique to your phone. If you still have your phone, just dial *#06# (star hash 0 6 hash).</span>
<br>
<span class="npfsubquestion">If you don't have your phone you can find it:
<ul>
    <li>Printed on a label on the box or in the packaging your phone came in</li>
        <li>By contacting your network provider - their number will be on their website or on a recent mobile phone bill</li>
</ul></span>
    </b-alert>
</b-collapse>

        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <b-row>
        <b-col cols="12">
          <span class="npfQuestion">Any other information</span>
      <br>
      <span class="npfsubquestion">For example, colour, case, estimated value, etc.</span>
          <b-form-textarea
            v-model="Property.anyother"
            rows="5"
            max-rows="12"
            placeholder="For example, colour, case, estimated value, etc."
          ></b-form-textarea>
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <b-row>
        <b-col cols="12">
          <b-button v-on:click="$emit('cancelpropertyelectronic')" variant="danger">
            Cancel
            <font-awesome-icon :icon="['fas', 'times-circle']"></font-awesome-icon>
          </b-button>
          <b-button v-on:click="addchildproperty()" variant="success">
            Add Property
            <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>&nbsp;
            <font-awesome-icon :icon="['fas', 'mobile-alt']"></font-awesome-icon>
          </b-button>
        </b-col>
      </b-row>
    </b-form-group>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      Property: {
        type: "",
        makeandmodel: "",
        imei: "",
        anyother:""
      },
      error: false,
      errormessage: []
    };
  },
  methods: {
    addchildproperty: function() {
      this.error = false;
      this.errormessage = [];

      if (this.Property.type == "") {
        this.error = true;
        this.errormessage.push("Please select a property type");
      }
        if (this.Property.makeandmodel == "" && this.Property.imei == "" && this.Property.anyother == "") {
        this.error = true;
        this.errormessage.push("Please supply more information, either 'Make and model', 'IMEI number' or any other identifiable details");
      }
      if (!this.error) {
        this.$emit("addpropertyelectronic", this.Property);
      }
      else  
      {
          this.errorMessage();
      }
    },
     errorMessage() {
      var errormessage = this.errormessage;
      var htmlerror = "<div style='text-align: left;'><ul>";
      errormessage.forEach(function(item) {
        htmlerror += "<li>" + item + "</li>";
      });
      htmlerror += "</ul></div>";

      this.$swal("Validation Error(s)", htmlerror, "error");
    },
  }
};
</script>

<style>
</style>
